import { render, staticRenderFns } from "./BsAvatar.vue?vue&type=template&id=1f81088c&"
import script from "./BsAvatar.vue?vue&type=script&lang=js&"
export * from "./BsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BsAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports